import _ from 'lodash'
import Constants from '@/constants'
import Util from '@/util'
import moment from 'moment'

const FormConstants = Object.freeze({
  Form: {
    COLUMNS: [{
      name: 'field',
      type: 'input',
      label: 'Field Of Certification In Which You Desire To Work?',
      class: 'is-6',
      disabled: true,
    }, {
      name: 'created_at',
      type: 'input',
      label: 'Application Date',
      class: 'is-6',
      disabled: true,
    }, {
      name: 'name',
      type: 'input',
      label: 'First Name',
      class: 'is-4'
    }, {
      name: 'mname',
      type: 'input',
      label: 'Middle Name',
      class: 'is-4'
    }, {
      name: 'lname',
      type: 'input',
      label: 'Last Name',
      class: 'is-4'
    }, {
      name: 'address',
      type: 'input',
      label: 'Address Line 1',
      class: 'is-12'
    }, {
      name: 'address2',
      type: 'input',
      label: 'Address Line 2',
      class: 'is-12'
    }, {
      name: 'city',
      type: 'input',
      label: 'City',
      class: 'is-4'
    }, {
      name: 'state',
      type: 'select',
      label: 'State',
      data: 'optionsState',
      class: 'is-4'
    }, {
      name: 'zip',
      type: 'input',
      label: 'Zip Code',
      class: 'is-4'
    }, {
      isSpan: true,
      class: 'is-12 is-hidden-mobile'
    }, {
      name: 'isRelocate',
      type: 'select',
      data: 'dataSelectYesNo',
      label: 'Are you willing to re-locate?',
      class: 'is-4'
    }, {
      name: 'relocateTo',
      type: 'input',
      label: 'If yes, where?',
      class: 'is-4',
      disabled: true,
    }, {
      isSpan: true,
      class: 'is-12 is-hidden-mobile'
    }, {
      name: 'phone',
      type: 'input',
      label: 'Phone Number',
      class: 'is-4'
    }, {
      name: 'email',
      type: 'input',
      label: 'Email Address',
      class: 'is-4'
    }, {
      isSpan: true,
      class: 'is-12 is-hidden-mobile'
    }, {
      name: 'dateAvailable',
      type: 'date_picker',
      label: 'Date Available',
      class: 'is-4',
      pickerOptions: Util.date.getOptionsFromToday(),
    }, {
      name: 'desiredCompensation',
      type: 'input',
      label: 'Desired Compensation (hourly)',
      class: 'is-4'
    }, {
      isSpan: true,
      class: 'is-12 is-hidden-mobile'
    }, {
      name: 'isProvidedService',
      type: 'select',
      data: 'dataSelectYesNo',
      label: 'Have you ever previously provided services for this company?',
      class: 'is-8'
    }, {
      isSpan: true,
      class: 'is-12 is-hidden-mobile'
    }, {
      name: 'providedServiceDateFrom',
      type: 'date_picker',
      label: 'If yes, from',
      class: 'is-4',
      disabled: true,
      pickerOptions: Util.date.getOptionsFromToday(),
    }, {
      name: 'providedServiceDateTo',
      type: 'date_picker',
      label: 'To',
      class: 'is-4',
      disabled: true,
      pickerOptions: Util.date.getOptionsFromToday(),
    }],

    KEYS: [
      { key: 'field', type: 'string', default: undefined },
      { key: 'created_at', type: 'date', default: moment().format('DD MMM, YYYY') },
      { key: 'name', type: 'string', default: undefined },
      { key: 'mname', type: 'string', default: undefined },
      { key: 'lname', type: 'string', default: undefined },
      { key: 'address', type: 'string', default: undefined },
      { key: 'address2', type: 'string', default: undefined },
      { key: 'city', type: 'string', default: undefined },
      { key: 'state', type: 'string', default: undefined },
      { key: 'zip', type: 'string', default: undefined },
      { key: 'phone', type: 'string', default: undefined },
      { key: 'email', type: 'string', default: undefined },
      { key: 'isRelocate', type: 'int', default: undefined, alias: 'option1' },
      { key: 'relocateTo', type: 'string', default: undefined, alias: 'text1' },
      { key: 'dateAvailable', type: 'date', default: undefined, alias: 'text2' },
      { key: 'desiredCompensation', type: 'string', default: undefined, alias: 'text3' },
      { key: 'isProvidedService', type: 'int', default: undefined, alias: 'option2' },
      { key: 'providedServiceDateFrom', type: 'date', default: undefined, alias: 'range1' },
      { key: 'providedServiceDateTo', type: 'date', default: undefined, alias: 'range2' },
    ],

    KEYS_FILL: [
      { key: 'field', type: 'string', default: 'Sample Field' },
      { key: 'created_at', type: 'date', default: moment().format('DD MMM, YYYY') },
      { key: 'name', type: 'string', default: 'A Name' },
      { key: 'mname', type: 'string', default: 'A Middle Name' },
      { key: 'lname', type: 'string', default: 'A Last Name' },
      { key: 'address', type: 'string', default: 'An Address 1' },
      { key: 'address2', type: 'string', default: 'An Address 2' },
      { key: 'city', type: 'string', default: 'City1' },
      { key: 'state', type: 'string', default: 'State1' },
      { key: 'zip', type: 'string', default: '112233' },
      { key: 'phone', type: 'string', default: '0112223333' },
      { key: 'email', type: 'string', default: 'adaptconceptsdev@gmail.com' },
      { key: 'isRelocate', type: 'int', default: Constants.OptionsYesNo.YES },
      { key: 'relocateTo', type: 'string', default: 'Some Place' },
      { key: 'dateAvailable', type: 'date', default: '1/18/2022' },
      { key: 'desiredCompensation', type: 'string', default: '1000' },
      { key: 'isProvidedService', type: 'int', default: Constants.OptionsYesNo.YES },
      { key: 'providedServiceDateFrom', type: 'date', default: '1/19/2022' },
      { key: 'providedServiceDateTo', type: 'date', default: '1/20/2022' },
    ],

    getValidators: (instance, params = {}) => {
      let isRelocate = params.isRelocate
      let isProvidedService = params.isProvidedService
      let validators = {
        field: [{ required: true, trigger: 'blur', message: 'Required' }],
        created_at: [{ required: true, trigger: 'blur', message: 'Required' }],
        name: [{ required: true, trigger: 'blur', message: 'Required' }],
        // mname: [{ required: true, trigger: 'blur', message: 'Required' }],
        lname: [{ required: true, trigger: 'blur', message: 'Required' }],
        address: [{ required: true, trigger: 'blur', message: 'Required' }],
        // address2: [{ required: true, trigger: 'blur', message: 'Required' }],
        city: [{ required: true, trigger: 'blur', message: 'Required' }],
        state: [{ required: true, trigger: 'change', message: 'Required' }],
        zip: [{ required: true, trigger: 'blur', message: 'Required' }],
        phone: [
          { required: true, trigger: 'blur', message: 'Required' },
          { required: true, trigger: 'blur', validator: Util.validators.validatorRegex.bind(instance), regex: new RegExp('^(\\([0-9]{3}\\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$'), message: 'Invalid format, e.g.: (123)123-1234' },
        ],
        email: [
          { required: true, trigger: 'blur', message: 'Required' },
          { required: true, trigger: 'blur', validator: Util.validators.validateEmail.bind(instance) }
        ],
        // extra info
        isRelocate: [{ required: true, trigger: 'change', message: 'Required' }],
        relocateTo: [{ required: isRelocate, trigger: 'blur', message: 'Required' }],
        dateAvailable: [{ required: true, trigger: 'blur', message: 'Required' }],
        desiredCompensation: [{ required: true, trigger: 'blur', message: 'Required' }],
        isProvidedService: [{ required: true, trigger: 'change', message: 'Required' }],
        providedServiceDateFrom: [{ required: isProvidedService, trigger: 'blur', message: 'Required' }],
        providedServiceDateTo: [{ required: isProvidedService, trigger: 'blur', message: 'Required' }],
        // images: [{ required: true, trigger: 'change', validator: Util.validators.validateFileRequired.bind(instance) }],
      }
      return validators
    },

    ENABLERS: [
      {
        key: 'relocateTo',
        criteria: [
          { param: 'isRelocate', value: Constants.OptionsYesNo.YES }
        ]
      }, {
        key: 'providedServiceDateFrom',
        criteria: [
          { param: 'isProvidedService', value: Constants.OptionsYesNo.YES }
        ]
      }, {
        key: 'providedServiceDateTo',
        criteria: [
          { param: 'isProvidedService', value: Constants.OptionsYesNo.YES }
        ]
      },
    ],

    updateEnablers: (instance, columns, form = {}) => {
      let enablers = FormConstants.Form.ENABLERS
      for (let e in enablers) {
        let enabler = enablers[e]
        let key = enabler.key
        let criterias = enabler.criteria || []
        let disabled = (!criterias || criterias.length <= 0)
        for (let c in criterias) {
          let criteria = criterias[c]
          let param = criteria.param
          let value = criteria.value
          if (!form.hasOwnProperty(param)) {
            disabled = true
            continue
          }
          if (form[param] !== value) {
            disabled = true
            continue
          }
        }
        let found = _.find(columns, (col) => col.name === key)
        if (found) {
          instance.$set(found, 'disabled', disabled)
        }
      }
    },
  },

  FormRef: {
    KEYS: [
      { key: 'ref{%refNo%}name', type: 'string', default: undefined },
      { key: 'ref{%refNo%}lname', type: 'string', default: undefined },
      { key: 'ref{%refNo%}phone', type: 'phone', default: undefined },
      { key: 'ref{%refNo%}email', type: 'email', default: undefined },
      { key: 'ref{%refNo%}company', type: 'string', default: undefined },
      { key: 'ref{%refNo%}relation', type: 'string', default: undefined },
    ],

    KEYS_FILL: [
      { key: 'ref{%refNo%}name', type: 'string', default: 'A Name' },
      { key: 'ref{%refNo%}lname', type: 'string', default: 'A Last Name' },
      { key: 'ref{%refNo%}phone', type: 'phone', default: '111222333' },
      { key: 'ref{%refNo%}email', type: 'email', default: 'some@test.com' },
      { key: 'ref{%refNo%}company', type: 'string', default: 'A Company' },
      { key: 'ref{%refNo%}relation', type: 'string', default: 'A Relationship' },
    ],

    getKeys: (refNo = 1, keys = FormConstants.FormRef.KEYS) => {
      let keyinfos = Util.array.copy(keys)
      for (let k in keyinfos) {
        let keyinfo = keyinfos[k]
        let key = keyinfo.key
        if (key) keyinfo.key = key.replace(/{%refNo%}/g, `${refNo}`)
      }
      return keyinfos
    },

    getValidators: (instance, refNo = 1) => {
      let keyinfos = Util.array.copy(FormConstants.FormRef.KEYS)
      let validators = {}
      for (let k in keyinfos) {
        let keyinfo = keyinfos[k]
        let key = keyinfo.key
        let type = keyinfo.type
        if (key) key = key.replace(/{%refNo%}/g, `${refNo}`)
        switch (type) {
          case 'string':
            validators[key] = [{ required: true, trigger: 'blur', message: 'Required' }]
            break
          case 'email':
            validators[key] = [
              { required: true, trigger: 'blur', message: 'Required' },
              { required: true, trigger: 'blur', validator: Util.validators.validateEmail.bind(instance) }
            ]
            break
          case 'phone':
            validators[key] = [
              { required: true, trigger: 'blur', message: 'Required' },
              { required: true, trigger: 'blur', validator: Util.validators.validatorRegex.bind(instance), regex: new RegExp('^(\\([0-9]{3}\\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$'), message: 'Invalid format, e.g.: (123)123-1234' },
            ]
            break
          default:
            throw new Error(`not supported type: ${type} in getValidators()`)
        }
      }
      return validators
    },

    COLUMNS: [{
      name: 'ref{%refNo%}name',
      type: 'input',
      label: 'First Name',
      class: 'is-4'
    }, {
      name: 'ref{%refNo%}lname',
      type: 'input',
      label: 'Last Name',
      class: 'is-4'
    }, {
      isSpan: true,
      class: 'is-12 is-hidden-mobile'
    }, {
      name: 'ref{%refNo%}phone',
      type: 'input',
      label: 'Phone Number',
      class: 'is-4'
    }, {
      name: 'ref{%refNo%}email',
      type: 'input',
      label: 'Email Address',
      class: 'is-4'
    }, {
      isSpan: true,
      class: 'is-12 is-hidden-mobile'
    }, {
      name: 'ref{%refNo%}company',
      type: 'input',
      label: 'Company',
      class: 'is-4'
    }, {
      name: 'ref{%refNo%}relation',
      type: 'input',
      label: 'Relation',
      class: 'is-4'
    }],

    getColumns: (refNo = 1) => {
      let columns = Util.array.copy(FormConstants.FormRef.COLUMNS)
      for (let k in columns) {
        let col = columns[k]
        let name = col.name
        if (name) col.name = name.replace(/{%refNo%}/g, `${refNo}`)
      }
      return columns
    }
  },

  FormUpload: {
    COLUMNS: [{
      name: 'files',
      label: '‌‌ ',
      buttonLabel: 'Choose File',
      buttonStyle: {
        borderRadius: '24px',
      },
      tip: 'Max file size: 60 MB.',
      // labelCustom: {
      //   type: 'link',
      //   isExternal: true,
      //   label: 'Guideline',
      //   url: 'https://sta360piris.blob.core.windows.net/iris-acc360-docs/A360OnboardingProcessImages.pdf'
      // },
      type: 'upload',
      listType: 'picture',
      // accept: 'image/png,image/jpeg,image/jpg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf',
      accept: 'application/pdf,application/msword,image/png,image/jpeg,image/jpg',
      limit: 1,
      // isUploadHidden: true,
      // isCustomUpload: true, // custom upload
      // isCustomUploadLabel: 'Upload/Gallery',
      uploadPrefix: 'listing/variant/',
      isAutoUpload: false,
      class: 'is-4',
      // prefixInfo: {
      //   label: 'Upload the product’s main (front) image for each SKU. If the product contains more than one SKU due to different flavors, colors, sizes, etc… the default image should reflect that.'
      // }
    }],

    KEYS: [
      { key: 'files', type: 'file', default: [] },
    ],

    getValidators: (instance, params = {}) => {
      let validators = {
        files: [{ required: true, trigger: 'change', validator: Util.validators.validateFileRequired.bind(instance) }],
      }
      return validators
    },
  }
})

export default FormConstants
